<button class="btn-back" (click)="onBack()">
  <span class="icon-wrapper">
    <cx-icon [type]="iconType.ARROW_NAVIGATE"></cx-icon>
  </span>
  <span class="label">Назад</span>
</button>

<div class="content">
  <div *ngIf="shop.address" class="row">
    <div class="name">Забрать по адресу</div>
    <div class="value">{{ shop.addressFormatted }}</div>
  </div>
  <div *ngIf="shop.address" class="row">
    <div class="name">Время работы</div>
    <div class="value shop-worktime">
      <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
    </div>
  </div>
  <div class="row">
    <div class="name">Можно забрать</div>
    <div class="value">
      {{
        shop.pickupDate
          ? (shop.pickupDate | uiTodayTomorrowDate: 'd MMMM' : { capitalized: true })
          : 'Дату самовывоза уточнит оператор'
      }}
    </div>
  </div>
</div>

<button class="btn btn-light btn-primary btn-block btn-sticky" (click)="onSelect()">Выбрать</button>
